import { create } from 'zustand';

export enum VALIDATION_STATUS {
  RUNNING = 'running',
  COMPLETED = 'completed',
}

export interface ValidationStore {
  validationStates: Record<string, VALIDATION_STATUS>;
  runningValidationIds: string[];

  startValidationRun: (validationIds: string[]) => void;
  completeValidation: (validationId: string) => void;
  reset: () => void;

  getValidationState: (validationId: string) => VALIDATION_STATUS | undefined;
  isValidationRunning: (validationId: string) => boolean;
}

const initialState = {
  validationStates: {},
  runningValidationIds: [],
};

export const useValidationStore = create<ValidationStore>((set, get) => ({
  ...initialState,

  startValidationRun: (validationIds: string[]) => {
    const { validationStates, runningValidationIds } = get();
    const newValidationStates = { ...validationStates };

    validationIds.forEach(id => {
      newValidationStates[id] = VALIDATION_STATUS.RUNNING;
    });

    set({
      validationStates: newValidationStates,
      // Added to, not replaced: a second edit can set one going while the
      // first edit's are still out at the runner.
      runningValidationIds: [...new Set([...runningValidationIds, ...validationIds])],
    });
  },

  completeValidation: (validationId: string) => {
    const { validationStates, runningValidationIds } = get();

    set({
      validationStates: { ...validationStates, [validationId]: VALIDATION_STATUS.COMPLETED },
      runningValidationIds: runningValidationIds.filter(id => id !== validationId),
    });
  },

  reset: () => {
    set(initialState);
  },

  getValidationState: (validationId: string) => {
    const { validationStates } = get();
    return validationStates[validationId];
  },

  isValidationRunning: (validationId: string) => {
    const { validationStates } = get();
    return validationStates[validationId] === VALIDATION_STATUS.RUNNING;
  },
}));
